import * as ReactRedux from 'react-redux';
import { AccountType, AccountCreationRequest, AccountCreationError } from './signup.types';
import AccountCreationComponent from './account.creation.component';
import { AppState } from '../app/app.types';

type OwnProps = {
  readonly whichAccount: (value: AccountType) => void
  readonly accountCreationRequestHandler: (request: AccountCreationRequest) => void
  readonly accountCreationErrorHandler: (error: AccountCreationError) => void
  readonly accountCreationError: AccountCreationError
  readonly checkEmailAvailability: (email: string) => Promise<Response>
};

const mapDispatchToProps = (dispatch: Function, ownProps: OwnProps) => {
  return {
    whichAccount: ownProps.whichAccount,
    accountCreationRequestHandler: ownProps.accountCreationRequestHandler
  };
};

const mapStateToProps = (appState: AppState) => {
  return {
    authState: appState.authState,
    signupState: appState.signupState
  };
};

const AccountCreation: React.ComponentClass<OwnProps> = 
  ReactRedux.connect(mapStateToProps, mapDispatchToProps)(AccountCreationComponent);

export default AccountCreation;



// WEBPACK FOOTER //
// ./src/admin/account.creation.tsx